import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { BaseComponent } from '@macs-frontend/core';
import { environment as env } from '../../../../../environments/environment';
import { Role } from '../../models/role.model';

@Component({
  /* eslint-disable-next-line @angular-eslint/component-selector */
  selector: 'md-add-role',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './add-role.component.html',
})
export class AddRoleComponent extends BaseComponent {
  // @ts-expect-error
  @Input() roles: Role[];
  // @ts-expect-error
  @Input() active: boolean;
  // @ts-expect-error
  @Input() permissions: string[];
  @Output() hide: EventEmitter<any> = new EventEmitter();
  @Output() addNewRole: EventEmitter<Role> = new EventEmitter();
  @Output() createNewRole: EventEmitter<string> = new EventEmitter();
  // @ts-expect-error
  newRole: Role;
  // @ts-expect-error
  newRoleName: string;

  imagesPath = env.images_path;

  handleCloseClick() {
    this.hide.emit();
  }

  handleRoleSelect(role: Role) {
    this.newRole = role;
    this.newRoleName = '';
  }

  addNew() {
    if (this.newRoleName) {
      this.createNewRole.emit(this.newRoleName);
      this.newRoleName = '';
    } else {
      this.addNewRole.emit(this.newRole);
      // @ts-expect-error
      this.newRole = null;
    }
  }

  onKeyUp(e: any) {
    this.newRoleName = e.target.value;
    if (this.newRoleName.length === 0) {
      // @ts-expect-error
      this.newRole = null;
    }
  }
}
